// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* assets/css/Calendar.css */
.custom-calendar {
  width: 100%;
  height: 100%; /* Ensure it takes full height of its container */
  display: flex;
  flex-direction: column;
}

.custom-calendar .react-calendar__viewContainer {
  width: 100%;
  height: 100%; /* Ensure it takes full height of its parent */
}

.custom-calendar .react-calendar__month-view {
  flex: 1 1;
  width: 100%;
  height: 100%; /* Ensure it takes full height of its parent */
  display: flex;
  flex-direction: column;
}

.custom-calendar .react-calendar__month-view > div[style*="display: flex;"] {
  display: flex !important;
  width: 100% !important;
  height: 100% !important;
  align-items: stretch !important;
}

.custom-calendar .react-calendar__month-view__days {
  display: flex;
  /* flex-wrap: wrap; */
  flex-grow: 1;
  align-items: center;
  height: 100%; /* Ensure it takes full height of its parent */
  max-height: 95%;
}

.custom-calendar .react-calendar__tile {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  align-items: stretch;
  height: 100% !important; /* Ensure it takes full height of its parent */
  box-sizing: border-box;
  max-height: 16.666%;
}

.custom-calendar .react-calendar__tile button {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  justify-content: center;
  align-items: center;
  padding: 0;
  margin: 0;
  border: none;
  background: transparent;
  height: 100%; /* Ensure it takes full height of its parent */
}

.custom-calendar .tile-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center; /* Center content vertically */
  width: 100%;
  height: 100%; /* Use the entire space available */
  box-sizing: border-box;
}

/* .custom-calendar .tile-date {
  font-size: 10rem !important;
  align-items: end;
  height: 100% !important;
  } */
  





body.chakra-ui-dark .custom-calendar .react-calendar__tile {
  /* color: white; */
  border-radius: 15px;
  /* border: 1px solid white; */
  padding: 2px !important;
  /* box-sizing: border-box; */
}

body.chakra-ui-dark .custom-calendar .tile-orders {
  font-size: 1rem;
  font-weight: 800;
  /* color: #00E5D1 !important; */
  color: black;
  align-self: center !important;
  justify-content: center !important;
}

body.chakra-ui-dark .custom-calendar .react-calendar__tile--now,
body.chakra-ui-dark .custom-calendar.react-calendar__tile--now:enabled:hover,
body.chakra-ui-dark .custom-calendar .react-calendar__tile--now:enabled:focus {
  background-color: transparent;
}

body.chakra-ui-dark .custom-calendar .react-calendar__tile--rangeEnd:enabled,
body.chakra-ui-dark .custom-calendar .react-calendar__tile--rangeEnd:enabled:hover,
body.chakra-ui-dark .custom-calendar .react-calendar__tile--rangeEnd:enabled:focus {
  background: transparent;
}

.custom-calendar .react-calendar__tile {
  /* color: black; */
  border-radius: 15px;
  /* border: 1px solid white; */
  padding: 2px !important;
  /* box-sizing: border-box; */
}

.custom-calendar .tile-orders {
  font-size: 1rem;
  font-weight: 800;
  /* color: #00E5D1 !important; */
  color: white;
  align-self: center !important;
  justify-content: center !important;
}

.custom-calendar .react-calendar__tile--now,
.custom-calendar.react-calendar__tile--now:enabled:hover,
.custom-calendar .react-calendar__tile--now:enabled:focus {
  background-color: transparent;
}

.custom-calendar .react-calendar__tile--rangeEnd:enabled,
.custom-calendar .react-calendar__tile--rangeEnd:enabled:hover,
.custom-calendar .react-calendar__tile--rangeEnd:enabled:focus {
  background: transparent;
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/Calendar.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B;EACE,WAAW;EACX,YAAY,EAAE,iDAAiD;EAC/D,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY,EAAE,8CAA8C;AAC9D;;AAEA;EACE,SAAO;EACP,WAAW;EACX,YAAY,EAAE,8CAA8C;EAC5D,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,sBAAsB;EACtB,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,YAAY;EACZ,mBAAmB;EACnB,YAAY,EAAE,8CAA8C;EAC5D,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,oBAAoB;EACpB,uBAAuB,EAAE,8CAA8C;EACvE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,SAAS;EACT,YAAY;EACZ,uBAAuB;EACvB,YAAY,EAAE,8CAA8C;AAC9D;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB,EAAE,8BAA8B;EACvD,WAAW;EACX,YAAY,EAAE,mCAAmC;EACjD,sBAAsB;AACxB;;AAEA;;;;KAIK;;;;;;;AAOL;EACE,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,YAAY;EACZ,6BAA6B;EAC7B,kCAAkC;AACpC;;AAEA;;;EAGE,6BAA6B;AAC/B;;AAEA;;;EAGE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,YAAY;EACZ,6BAA6B;EAC7B,kCAAkC;AACpC;;AAEA;;;EAGE,6BAA6B;AAC/B;;AAEA;;;EAGE,uBAAuB;AACzB","sourcesContent":["/* assets/css/Calendar.css */\n.custom-calendar {\n  width: 100%;\n  height: 100%; /* Ensure it takes full height of its container */\n  display: flex;\n  flex-direction: column;\n}\n\n.custom-calendar .react-calendar__viewContainer {\n  width: 100%;\n  height: 100%; /* Ensure it takes full height of its parent */\n}\n\n.custom-calendar .react-calendar__month-view {\n  flex: 1;\n  width: 100%;\n  height: 100%; /* Ensure it takes full height of its parent */\n  display: flex;\n  flex-direction: column;\n}\n\n.custom-calendar .react-calendar__month-view > div[style*=\"display: flex;\"] {\n  display: flex !important;\n  width: 100% !important;\n  height: 100% !important;\n  align-items: stretch !important;\n}\n\n.custom-calendar .react-calendar__month-view__days {\n  display: flex;\n  /* flex-wrap: wrap; */\n  flex-grow: 1;\n  align-items: center;\n  height: 100%; /* Ensure it takes full height of its parent */\n  max-height: 95%;\n}\n\n.custom-calendar .react-calendar__tile {\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  align-items: stretch;\n  height: 100% !important; /* Ensure it takes full height of its parent */\n  box-sizing: border-box;\n  max-height: 16.666%;\n}\n\n.custom-calendar .react-calendar__tile button {\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  justify-content: center;\n  align-items: center;\n  padding: 0;\n  margin: 0;\n  border: none;\n  background: transparent;\n  height: 100%; /* Ensure it takes full height of its parent */\n}\n\n.custom-calendar .tile-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center; /* Center content vertically */\n  width: 100%;\n  height: 100%; /* Use the entire space available */\n  box-sizing: border-box;\n}\n\n/* .custom-calendar .tile-date {\n  font-size: 10rem !important;\n  align-items: end;\n  height: 100% !important;\n  } */\n  \n\n\n\n\n\nbody.chakra-ui-dark .custom-calendar .react-calendar__tile {\n  /* color: white; */\n  border-radius: 15px;\n  /* border: 1px solid white; */\n  padding: 2px !important;\n  /* box-sizing: border-box; */\n}\n\nbody.chakra-ui-dark .custom-calendar .tile-orders {\n  font-size: 1rem;\n  font-weight: 800;\n  /* color: #00E5D1 !important; */\n  color: black;\n  align-self: center !important;\n  justify-content: center !important;\n}\n\nbody.chakra-ui-dark .custom-calendar .react-calendar__tile--now,\nbody.chakra-ui-dark .custom-calendar.react-calendar__tile--now:enabled:hover,\nbody.chakra-ui-dark .custom-calendar .react-calendar__tile--now:enabled:focus {\n  background-color: transparent;\n}\n\nbody.chakra-ui-dark .custom-calendar .react-calendar__tile--rangeEnd:enabled,\nbody.chakra-ui-dark .custom-calendar .react-calendar__tile--rangeEnd:enabled:hover,\nbody.chakra-ui-dark .custom-calendar .react-calendar__tile--rangeEnd:enabled:focus {\n  background: transparent;\n}\n\n.custom-calendar .react-calendar__tile {\n  /* color: black; */\n  border-radius: 15px;\n  /* border: 1px solid white; */\n  padding: 2px !important;\n  /* box-sizing: border-box; */\n}\n\n.custom-calendar .tile-orders {\n  font-size: 1rem;\n  font-weight: 800;\n  /* color: #00E5D1 !important; */\n  color: white;\n  align-self: center !important;\n  justify-content: center !important;\n}\n\n.custom-calendar .react-calendar__tile--now,\n.custom-calendar.react-calendar__tile--now:enabled:hover,\n.custom-calendar .react-calendar__tile--now:enabled:focus {\n  background-color: transparent;\n}\n\n.custom-calendar .react-calendar__tile--rangeEnd:enabled,\n.custom-calendar .react-calendar__tile--rangeEnd:enabled:hover,\n.custom-calendar .react-calendar__tile--rangeEnd:enabled:focus {\n  background: transparent;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
